















import {
  Component,
  Prop,
  Vue,
  Emit,
} from 'vue-property-decorator';

@Component
export default class ContactInput extends Vue {
  @Prop({ required: true, type: String, default: 'name' }) name!: string;

  @Prop({ required: true, type: String, default: 'type' }) type!: string;

  @Prop({ required: true, type: String, default: 'value' }) value!: string;

  @Prop({ required: true, type: String, default: 'label' }) label!: string;

  @Prop({ type: String, default: null }) error!: string;

  @Emit('onChangeValue')
  // eslint-disable-next-line class-methods-use-this
  private updateValue(event: object) {
    return event;
  }
}
